/** Matches Integrations::App::SUPER_ADMIN_ONLY_APP_IDS in Ruby */
export const SUPER_ADMIN_ONLY_INTEGRATION_IDS = [
  'webhook',
  'dashboard_apps',
  'openai',
  'dialogflow',
  'google_translate',
  'dyte',
];
